var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-chart',{attrs:{"chartType":"ve-pie","chartData":_vm.chartData,"chartConfig":_vm.chartConfig,"chartSettings":_vm.chartSettings,"loading":_vm.loading,"emptyContent":_vm.emptyContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }